import React from 'react';
import GenericModal from './GenericModal';

export default function GuideModal({ isOpen, onClose, children, footerExtras = null }) {
  return (
    <GenericModal isOpen={isOpen} onClose={onClose} draggable dragHandleSelector=".guide-modal-header" fitToContent>
      {/* Invisible top drag handle with space for the close button on the right */}
      <div className="absolute top-0 left-0 right-10 h-6 guide-modal-header cursor-grab active:cursor-grabbing" />
      <div className="guide-modal-header select-none cursor-grab active:cursor-grabbing mb-3" />
      <div className="break-words whitespace-normal text-lg md:text-xl">
        {children}
      </div>
      <div className="mt-6 flex items-center justify-between gap-3">
        <div className="flex flex-wrap gap-2">
          {footerExtras}
        </div>
        <button
          type="button"
          onClick={onClose}
          className="px-4 py-2 rounded bg-blue-600 hover:bg-blue-700 text-white text-lg md:text-xl"
        >
          Got it
        </button>
      </div>
    </GenericModal>
  );
}

